import typeOfOperand from "../base/typeOfOperand";

export default function(value) {
    let typeOfValue = typeOfOperand(value);
    // usecase: required checkbox for "terms and condidtions"
    if (typeOfValue === "boolean") {
        return value;
    }

    if (typeOfValue === "string") {
        return value !== "";
    }

    if (value && value.hasOwnProperty("length")) {
        return !!value.length;
    }

    return value !== {} && value !== undefined && value !== null;
}
